import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GLOBALPROPS } from './GlobalApp.jsx';

import LoginForm from './M1/Forms/LoginForm.jsx';
import Loadable from 'react-loadable';
import Loading from './M1/Lib/Loading.jsx'
import { withStyles } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';

const SignUp = Loadable({
  loader: () => import('./M1/Forms/SignUp.jsx'),
  loading(props) { return ( <Loading message="Loading registration"  {...props}/> ); },
});

const PasswordLostForm = Loadable({
  loader: () => import('./M1/Forms/PasswordLostForm.jsx'),
  loading(props) { return ( <Loading message="Loading password"  {...props}/> ); },
});

const ChangePasswordForm = Loadable({
  loader: () => import('./M1/Forms/ChangePasswordForm.jsx'),
  loading(props) { return ( <Loading message="Loading password"  {...props}/> ); },
});

import { objectGet } from '../../../SharedLibs/Tools.js';



export const styles = () => ({
});

class NotLogged extends Component {

    

	constructor(props) {
		super(props);

        this.renderLogin = this.renderLogin.bind(this);
        this.renderPassLost = this.renderPassLost.bind(this);
		this.renderSignUp = this.renderSignUp.bind(this);
    }

    renderLogin() {
		let login = objectGet(this.props.global, "urlParams.login");
		let _pathname = objectGet(this.props.global, "urlParams._pathname");

		return (
		
					<LoginForm
						
						key="loginForm"
						_id="loginForm"
						login={login}
						_pathname={_pathname}
						global={this.props.global}
					/>
				
			
		);
	}


	renderPassLost() {
		let passlost = objectGet(this.props.global, "urlParams.passlost");
		let login = objectGet(this.props.global, "urlParams.login");
		let confirmstring = objectGet(this.props.global, "urlParams.confirmstring");
		let _pathname = objectGet(this.props.global, "urlParams._pathname", "/");

		if (passlost == "3")
			return (
				
						<ChangePasswordForm
							withoutBackButton={true}
							global={this.props.global}
							login={login}
							confirmString={confirmstring}
							_pathname={_pathname} />
				
			);

		return (
		
					<PasswordLostForm
						
						key="passLostForm"
						_id="passLostForm"
						withoutBackButton={true}
						email={this.props.global.urlParams.email}
						login={this.props.global.urlParams.login}
						confirmstring={this.props.global.urlParams.confirmstring}
						passlost={passlost}
						_pathname={this.props.global.urlParams._pathname}
						global={this.props.global}
					/>
			
		);
	}


	renderSignUp() {
		let login = objectGet(this.props.global, "urlParams.login");
		let signup = objectGet(this.props.global, "urlParams.signup");
		let email = objectGet(this.props.global, "urlParams.email");
		let confirmString = objectGet(this.props.global, "urlParams.confirmString");
		let _path = objectGet(this.props.global, "urlParams._path", "/");
		let _pathname = objectGet(this.props.global, "urlParams._pathname", "/");
		return (
				<SignUp
					
					key="signUpForm"
					_id="signUpForm"
					login={login}
					_path={_path}
					_pathname={_pathname}
					confirmString={confirmString}
					signup={signup}
					email={email}
					global={this.props.global}
				/>
		);
	}

    render(){

        if ( this.props.logged == true ) return "";

		// -------- Rendering a signup -----------
		if ( this.props.global.urlParams.signup ) return this.renderSignUp();
		// -------- Rendering a passlost -----------
		if ( this.props.global.urlParams.passlost ) return this.renderPassLost();

		return this.renderLogin();

    }
}

NotLogged.propTypes = {
	logged : PropTypes.bool,
	global : GLOBALPROPS,
  };

export default withWidth()(withStyles(styles,{withTheme:true})(NotLogged));



